import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { deleteNodeFile } from "api/services/node-service";
import { useCallback } from "react";
import { IDeleteNodeFileRequest } from "api/models/request/IDeleteNodeFileRequest";
import { ResourceType } from "models/ResourceType";

export const useDeleteNodeFile = () => {
    const {
        callAPI,
        loading
    } = useWorkspaceApiCall<IDeleteNodeFileRequest, any>(deleteNodeFile, 'deleteNodeFile.success', 'deleteNodeFile.error');

    const removeNodeFile = useCallback(async (editor: any, resourceType: ResourceType, fileId: string) => {
        const response = await callAPI({ fileId });

        if (response?.success) {
            editor.storage.setNodeFileRemoved(resourceType, fileId);
        }

        return response;
    }, [callAPI]);

    return { removeNodeFile, isLoading: loading };
}